import { webConstants } from "@payping/utils/platformConstants";
import { Button, Card, Space } from "@payping/web-components";
import React from "react";
import { Link } from "react-router-dom";

import { useAppTranslation } from "@/utils/useAppTranslation";
import {
  frequentProductListId,
  frequentServicesId,
  frequentSettingsId,
  frequentTokenCreateId,
} from "@/assets/googleTrackIds";

interface SmallButtonProps {
  text: string;
  url: string;
}

const SmallButton: React.FC<SmallButtonProps> = ({ text, url, ...otherProps }) => (
  <Link to={url} {...otherProps}>
    <Button ghost variant="primary" style={{ fontSize: "1.4vh", height: "fit-content", padding: "1vh" }}>
      {text}
    </Button>
  </Link>
);

const FrequentOperations: React.FC = () => {
  const { t } = useAppTranslation();
  const { DashboardRoutes } = webConstants;

  return (
    <Card.Raw>
      <Card.Raw.ColMeta header={<Card.Raw.RowMeta title={t("overview.frequentOperations.title")} />}>
        <Space style={{ flexWrap: "wrap", justifyContent: "flex-end", padding: "0 2vh", width: "100%" }}>
          <SmallButton
            text={t("overview.frequentOperations.settings")}
            url={DashboardRoutes.user.settings.root}
            data-google-track={frequentSettingsId}
          />
          <SmallButton
            text={t("overview.frequentOperations.items")}
            url={DashboardRoutes.product.list}
            data-google-track={frequentProductListId}
          />
          <SmallButton
            text={t("overview.frequentOperations.plugins")}
            url={DashboardRoutes.ipg.service.root}
            data-google-track={frequentServicesId}
          />
          <SmallButton
            text={t("overview.frequentOperations.createToken")}
            url={DashboardRoutes.ipg.token.create}
            data-google-track={frequentTokenCreateId}
          />
        </Space>
      </Card.Raw.ColMeta>
    </Card.Raw>
  );
};

export default FrequentOperations;
